/**
 * Verbessert die Barrierefreiheit für das JetEngine Smart Filters Pagination Widget.
 */
function initSmartFilterPaginationOptimization() {

    // --- Übersetzungen ---
    const i18nGlobal = (typeof WCO_UI_Translations !== 'undefined') ? WCO_UI_Translations : {};
    const i18nPag = i18nGlobal.pagination || {};

    const labelContainer = i18nPag.label    || 'Pagination';
    const labelPrev      = i18nPag.prev     || 'Previous page';
    const labelNext      = i18nPag.next     || 'Next page';
    const labelPageXofY  = i18nPag.pageXofY || 'Page %s of %s';

    /**
     * Diese Funktion führt alle A11Y-Optimierungen an einem gefundenen Pagination-Container durch.
     * @param {HTMLElement} paginationNode - Das .jet-filters-pagination Element.
     */
    const optimizePagination = (paginationNode) => {
        // `role` und `aria-label` für den Container
        paginationNode.setAttribute('role', 'navigation');
        paginationNode.setAttribute('aria-label', labelContainer);

        const links = paginationNode.querySelectorAll('.jet-filters-pagination__link');
        const numberLinks = Array.from(links).filter(link => !isNaN(parseInt(link.textContent, 10)));
        const totalPages = numberLinks.length;

        // Attribute für einzelne Links
        links.forEach(link => {
            const parentItem = link.closest('.jet-filters-pagination__item');
            if (!parentItem) return;
            const linkText = link.textContent.trim();
            let ariaLabel = '';

            // Prev/Next Buttons
            if (parentItem.classList.contains('prev')) {
                ariaLabel = labelPrev;
            } else if (parentItem.classList.contains('next')) {
                ariaLabel = labelNext;
            } else if (!isNaN(parseInt(linkText, 10))) {
                ariaLabel = labelPageXofY.replace('%s', linkText).replace('%s', totalPages);
            }

            // Label setzen (nur wenn eines definiert wurde)
            if (ariaLabel) {
                link.setAttribute('aria-label', ariaLabel);
            }

            // Aktuelles Element
            if (parentItem.classList.contains('jet-filters-pagination__current')) {
                link.setAttribute('aria-current', 'page');
            } else {
                link.removeAttribute('aria-current');
            }

            // Tabindex überall hinzufügen
            link.setAttribute('tabindex', '0');

            // Seite mit Enter wechseln
            if (link.dataset.keyboardInit) {
                return;
            }

            link.addEventListener('keydown', (event) => {
                if (event.key === 'Enter' || event.key === ' ') {
                    event.preventDefault();
                    link.click();
                }
            });

            link.dataset.keyboardInit = 'true';
        });

        paginationNode.dataset.a11yOptimized = 'true';
    };

    // MutationObserver
    const observeDOM = () => {
        const targetNode = document.body;
        const config = { childList: true, subtree: true };
        const callback = (mutationsList, observer) => {
            for (const mutation of mutationsList) {
                if (mutation.type === 'childList') {
                    const paginationNode = document.querySelector('.jet-filters-pagination:not([data-a11y-optimized])');
                    if (paginationNode) {
                        optimizePagination(paginationNode);
                    }
                }
            }
        };

        const observer = new MutationObserver(callback);
        observer.observe(targetNode, config);
    };

    const initialPagination = document.querySelector('.jet-filters-pagination');
    if (initialPagination) {
        optimizePagination(initialPagination);
    }

    observeDOM();
}

export { initSmartFilterPaginationOptimization };